var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout',{staticClass:"app-wrapper"},[_c('page-sidebar',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSidebar),expression:"isSidebar"}]}),_c('a-layout-content',{staticClass:"content-wrapper"},[_c('page-header'),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }